var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHitPrevious = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.5a.999.999 0 0 1-.777-1.628l10.5-13a1 1 0 0 1 .766-.372c.27.024.582.126.774.354l11 13a1 1 0 1 1-1.526 1.291L12.019 7.069 2.278 19.128a1 1 0 0 1-.778.372"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHitPrevious);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hit_previous.svg";